export function featureFlag(name: string): boolean {
  const map: Record<string, string | undefined> = {
    UI_CYCLE_SNAPSHOTS: import.meta.env.VITE_UI_CYCLE_SNAPSHOTS as string | undefined,
    UI_SIGNOFF_OPERATOR_ACCORDION: import.meta.env.VITE_UI_SIGNOFF_OPERATOR_ACCORDION as string | undefined,
    PDF_OPERATOR_STORE_MODE: import.meta.env.VITE_PDF_OPERATOR_STORE_MODE as string | undefined,
    PDF_OPERATOR_INSTRUCTIONS_PAGE: import.meta.env.VITE_PDF_OPERATOR_INSTRUCTIONS_PAGE as string | undefined,
    BULK_ASSIGNMENTS_OPTIMIZED: import.meta.env.VITE_BULK_ASSIGNMENTS_OPTIMIZED as string | undefined,
    BULK_ASSIGNMENTS_PHASE_2: import.meta.env.VITE_BULK_ASSIGNMENTS_PHASE_2 as string | undefined,
    BULK_ASSIGNMENTS_PHASE_3: import.meta.env.VITE_BULK_ASSIGNMENTS_PHASE_3 as string | undefined,
    STORE_FIRST_UI: import.meta.env.VITE_STORE_FIRST_UI as string | undefined,
    TASK_DISTRIBUTION_BOOTSTRAP: import.meta.env.VITE_TASK_DISTRIBUTION_BOOTSTRAP as string | undefined,
  };
  const val = map[name];
  
  // Default to true for STORE_FIRST_UI if not explicitly set
  if (name === 'STORE_FIRST_UI' && val === undefined) {
    return true;
  }
  
  return val === '1' || val === 'true' || val === 'on';
}

export function getFlag(name: string, defaultDev = true, defaultProd = false): boolean {
  const env = (import.meta as any).env || {};
  const raw = env[`VITE_${name}`];
  if (raw === undefined || raw === null || raw === '') {
    return env.DEV ? !!defaultDev : !!defaultProd;
  }
  if (typeof raw === 'boolean') return raw;
  const v = String(raw).toLowerCase();
  return v === '1' || v === 'true' || v === 'on' || v === 'yes';
}

// PDF Feature Flags
export function isPdfOperatorStoreModeConsolidated(): boolean {
  const mode = import.meta.env.VITE_PDF_OPERATOR_STORE_MODE as string;
  return mode === 'consolidated';
}

export function isPdfOperatorInstructionsPageEnabled(): boolean {
  return getFlag('PDF_OPERATOR_INSTRUCTIONS_PAGE', false, false);
}



